import { render } from "./Infoscreen.vue?vue&type=template&id=7f0bbbbf&scoped=true"
import script from "./Infoscreen.vue?vue&type=script&lang=js"
export * from "./Infoscreen.vue?vue&type=script&lang=js"

import "./Infoscreen.vue?vue&type=style&index=0&id=7f0bbbbf&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0bbbbf"]])

export default __exports__